import { useContext, useEffect } from "react";
import Parser from "html-react-parser";
import { useTranslation } from "react-i18next";

import "../src/styles/SecondStep.scss";

import { FormContext } from "./AppForm";

function FirstStepB() {
  const { values, errors, handleChange, setErrors } =
    useContext<any>(FormContext);
  const { t } = useTranslation();
  const Active = {
    backgroundColor: "#e7f1f1",
    border: "2px solid #3BA39C",
  };
  const InActive = {
    backgroundColor: "#f9f9f9",
    border: "",
  };

  const categories = [
    {
      name: "digital_products",
      text: t("signup__activity_digital_products"),
      class: "activity01",
    },
    {
      name: "music_school",
      text: t("signup__activity_music_school"),
      class: "activity02",
    },
    {
      name: "language_school",
      text: t("signup__activity_language_school"),
      class: "activity03",
    },
    {
      name: "swimming_school",
      text: t("signup__activity_swimming_school"),
      class: "activity04",
    },
    {
      name: "sport_club",
      text: t("signup__activity_sport_club"),
      class: "activity05",
    },
    {
      name: "kids_club",
      text: t("signup__activity_kids_club"),
      class: "activity06",
    },
    {
      name: "health_and_wellbeing",
      text: t("signup__activity_health_and_wellbeing"),
      class: "activity07",
    },
    {
      name: "dancing_school",
      text: t("signup__activity_dancing_school"),
      class: "activity08",
    },
    {
      name: "education",
      text: t("signup__activity_education"),
      class: "activity09",
    },
    {
      name: "other",
      text: t("signup__activity_other"),
      class: "activity10",
    },
  ];
  useEffect(() => {
    setErrors({ ...errors, category: "" });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="form-center">
      <h1>{t("signup__mission_heading")}</h1>
      <h2>{t("signup__mission_description")}</h2>
      <div className="form-center-activities">
        {categories.map((category: any, index) => (
          <label key={index} htmlFor={category.name}>
            <span
              className={category.name}
              style={values.category === category.name ? Active : InActive}
            >
              <input
                style={{ opacity: 0 }}
                onChange={handleChange}
                onClick={() => setErrors({ category: "" })}
                type="radio"
                value={category.name}
                name="category"
                id={category.name}
              />
              {Parser(category.text)}
            </span>
          </label>
        ))}
      </div>
      <span className="error">{errors.category}</span>
    </div>
  );
}

export default FirstStepB;
